// extracted by mini-css-extract-plugin
export default {"textContainer":"textContainer_textContainer__TZa0P","text":"textContainer_text__OgYRl","lastText":"textContainer_lastText__UKQ9T"};